import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap, tap } from 'rxjs/operators';
import { AppointmentsService } from '../../core/services/v2/appointments.service';
import { CommonService } from '../../core/services/v2/common.service';
import { PatientService } from '../../core/services/v2/patient.service';
import { PracticeService } from '../../core/services/v2/practice.service';
import { UserService } from '../../core/services/v2/user.service';
import { WindowLoaderService } from '../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-call-center-appointment-dialog',
  templateUrl: './call-center-appointment-dialog.component.html',
  styleUrls: ['./call-center-appointment-dialog.component.scss']
})
export class CallCenterAppointmentDialogComponent implements OnInit {
  reqestApptForm: FormGroup = this.fb.group({
    patientName: ['', Validators.required],
    patientId: ['', Validators.required],
    providerName: ['', Validators.required],
    providerId: ['', Validators.required],
    healthSystemId: ['0', Validators.required],
  });

  patientFilteredOptions: Observable<any>;
  providerFilteredOptions: Observable<any>;
  patientFavoritePractitioners: any;
  healthSystems: any;
  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    variableWidth: false,
    autoplay: false,
    arrows: true,
    prevArrow:
      '<button class="btn no-text prev"><span class="icon-arrow-left"></span></button>',
    nextArrow:
      '<button class="btn no-text next"><span class="icon-arrow-right"></span></button>',
  };
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CallCenterAppointmentDialogComponent>,
    private fb: FormBuilder,
    private userService: UserService,
    private appointmentService: AppointmentsService,
    private patientService: PatientService,
    private practiceService: PracticeService,
    public dialog: MatDialog,
    private router: Router,
    private loaderService: WindowLoaderService,
    private commonService: CommonService,) { }

  ngOnInit() {
    this.reqestApptForm.reset();
    this.patientFavoritePractitioners = null;
    this.patientFilteredOptions = this.reqestApptForm.controls.patientName.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((val) => {
        if (!val) {
          return new Observable<any[]>();
        }
        return this._filterPatient(val);
      })
    );

    this.providerFilteredOptions = this.reqestApptForm.controls.providerName.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((val) => {
        if (!val) {
          return new Observable<any[]>();
        }
        return this._filterProvider(val);
      })
    );
  }

  _filterPatient(filterValue) {
    return this.loaderService.blockWithLoader(this.patientService.getPatientDetailsByNameOrMobile(filterValue));
  }

  _filterProvider(filterValue) {
    const apiUrl = 'Practitioner/GetPractitionersByName?searchText=' + filterValue;
    return this.loaderService.blockWithLoader(this.commonService.getDynamicSearchApiData(apiUrl).pipe(
      tap(),
      map((response) => {
        return response.practitioners;
      })
    ));
  }
  setPatient(patient: any) {
    if (patient.preferredName) {
      this.reqestApptForm.controls.patientName.setValue(patient.preferredName);
    }
    else {
      this.reqestApptForm.controls.patientName.setValue(`${patient.firstName} ${patient.lastName}`);
    }
    this.reqestApptForm.controls.patientId.setValue(patient.id);
    this.getPatientFavoritesById(patient.id);
  }
  setProvider(provider: any) {
    this.reqestApptForm.controls.providerName.setValue(`${provider.practitionerName}`);
    const providerId = provider.practitionerId ? provider.practitionerId : provider.id;
    this.reqestApptForm.controls.providerId.setValue(providerId);
    this.loaderService.blockWithLoader(this.practiceService.getPractitionerDetails(providerId)).subscribe(
      (practitionerData) => {
        this.healthSystems = practitionerData.healthSystems ? practitionerData.healthSystems : [];
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getPatientName() {
    return this.reqestApptForm.controls.patientName.value;
  }
  getPatientFavoritesById(id) {
    this.loaderService.blockWithLoader(this.patientService.getPatientFavoritesById(id)).subscribe(
      (details) => {
        this.patientFavoritePractitioners = details.practitioners;
      },
      (error) => { console.error(error); }
    );
  }

  continue() {
    if (this.reqestApptForm.valid) {
      this.dialogRef.close();
      const patientId = this.reqestApptForm.controls.patientId.value;
      const providerId = this.reqestApptForm.controls.providerId.value;
      const healthSystemId = this.reqestApptForm.controls.healthSystemId.value;
      let dataToPass = {
        patientId,
        providerId,
        healthSystemId
      };
      this.router.navigate([
        "/callcenter/appointment",
        dataToPass
      ]);
    }
  }

  cancel() {
    this.dialogRef.close();
  }


}
